
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { Container, Grid, Modal } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardFooter from '../../Main/S7_Footer'
import up from '../../../../assets/images/dashboard.png'
import clock from '../../../../assets/images/clock.png'
import { P, SectionHeading, SectionSmallHeading, } from '../../../Styles/style'
import { ConnectButt, GridWrapper, PageCount, PageCounted, InpuDIv, Divider, } from '../Styles/style'

import Web3 from 'web3';
import { BuyNow } from '../../Main/S1_Header/styles'


const RadioCheckmark = styled.span`
display: inline-block;
height: 20px;
width: 20px;
border-radius: 50%;
border: 2px solid #ccc;
`;

const RadioCheckmarkSelected = styled(RadioCheckmark)`
background-color: #2f9c5f;
border-color: #2f9c5f;
`;

const EthBtn = styled.div`
display: flex;
align-items: center;
@media screen and (max-width:599px){
    text-align: center;
    display: inline-block;
}
`
const Div = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:7px 0;
`
const SectionSubHeading = styled.h3`
  text-shadow:0px 7px 19px rgba(255, 255, 255, 0.3);
  background:linear-gradient(60deg, #F8063A 20%,#0080FF 30%,#0080FF 27%,#FF0000 43%, #0080FF 60%,#0080FF 92%);
  
  /* background: -webkit-linear-gradient(15deg,#F8063A, #00D3FD, #00D3FD,#00D3FD ); */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "P-SB";
  font-size: ${(props) => (props.fs ? props.fs : "43px")};
  color: ${(props) => props.theme.textPrimary};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  /* line-height: ${(props) => (props.lh ? props.lh : "50px")}; */
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "CENTER")};
  
  @media screen and (max-width: 1199px) {
    /* font-size: 30px; */
  }
  @media (max-width: 599px) {
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
  @media (max-width: 399px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
  }
`;

const SectionWrapper = styled.div`
background-image: url(${up});
background-size:contain;
background-position:center;
background-repeat:no-repeat;
/* min-height:100vh; */
display:flex;
align-items:center;
  background: ${(props) => (props.bgColor ? props.bgColor : "")};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};
border-top:${(props) => (props.bt ? props.bt : "")};
  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "30px 0")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`;
const Modals = styled(Modal)`
  backdrop-filter: blur(2px);
`;
const DivWrap = styled.div`
    background-color:#01121E;
    box-shadow:0px 0px 7px 4px #002c4b52;
    padding:30px 20PX;
    BORDER-RADIUS:20PX;
`

const MainDiv = styled.div`
  display: flex;
  justify-content: center;
  text-align:center;
`;

const XButton = styled.button`
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  position:absolute;
  top:10px;
  right:10px;
  COLOR:#FFF;
`;

const DivForWithDraw = styled.div`
  padding: 20px 18px;
    background-color:#01121E;
    box-shadow:0px 0px 7px 4px #002c4b52;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border-radius: 10px;
  border: NONE;
  width: 600px;
  margin-top: 12%;
`;
const S1_Dashboard = (props) => {

    const [web3, setWeb3] = useState(null);
    const [account, setAccount] = useState(null);

    useEffect(() => {
        const initWeb3 = async () => {
            if (window.ethereum) {
                try {
                    const web3 = new Web3(window.ethereum);
                    const accounts = await web3.eth.getAccounts();
                    setWeb3(web3);
                    setAccount(accounts[0]);
                } catch (error) {
                    console.error(error);
                }
            } else {
                console.log('Please install MetaMask!');
            }
        };
        initWeb3();

        const handleAccountsChanged = (accounts) => {
            if (accounts.length === 0) {
                setAccount(null);
            } else {
                setAccount(accounts[0]);
            }
        };

        if (window.ethereum) {
            window.ethereum.on('accountsChanged', handleAccountsChanged);
        }

        return () => {
            if (window.ethereum) {
                window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
            }
        };
    }, []);

    const theme = useTheme();
    const [selectedValue, setSelectedValue] = useState('');
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const [selectedOption, setSelectedOption] = useState(false);
    const [isRadioSelected, setIsRadioSelected] = useState(false);

    const handleRadioChange = (e) => {
        setIsRadioSelected(e.target.checked);
        setSelectedOption(!selectedOption);
    }
    const handleChange = (value) => {
        setSelectedValue(value);
        setIsButtonEnabled(true);
    };

    const radioStyle = (value) => ({
        display: 'inline-table',
        // width: '100px',
        height: '50px',
        borderRadius: '10px',
        padding: '10px 30PX',
        textAlign: 'center',
        margin: '5px',
        border: selectedValue === value ? '1px solid #48BA7F' : '1px solid white',
        color: selectedValue === value ? theme.textTertiary : theme.textPrimary,
        cursor: 'pointer'
    });

    const [OpenModal, setOpenModal] = useState(false);

    const handleCloseModal = () => setOpenModal(false);
    const handleOpenModal = () => setOpenModal(true);
    return (
        <div>
            <SectionWrapper>
                <Container maxWidth="xl">
                    <GridWrapper container justifyContent="center">
                        <Grid xs={12} sm={7} md={5} lg={12}>
                            <SectionSubHeading>PULSE OTC</SectionSubHeading>
                            <SectionHeading p="0" m="0" fs="100px">DASHBOARD</SectionHeading>
                            <SectionSmallHeading p="0" m="0" align="center">How It Works</SectionSmallHeading>
                            <P align="center">Pick the amount of USDC that you would like to spend using your ERC20 wallet.<br />
                                You will be given an estimate for how many pulse tokens you can expect to receive. <br />
                                Once you click on the deposit button you will have to wait a <br />few minutes after confirmation before your tokens show up in your wallet.</P>
                            {account ? (
                                        <>
                                            <Grid container justifyContent="center">
                                                <Grid xs={12} sm={9} md={7} lg={6}>
                                                    <DivWrap >
                                                        <div >
                                                            <P p="0" m="0 0 20px">Select an amount of $USDC you like to spend</P>
                                                            <EthBtn>
                                                                <label style={radioStyle('100')} onClick={() => handleChange('100')}>
                                                                    <input type="radio" name={props.name} value="100" style={{ display: 'none' }} checked={selectedValue === '100'} onChange={() => { }} />
                                                                    $100
                                                                </label>
                                                                <label style={radioStyle('200')} onClick={() => handleChange('200')}>
                                                                    <input type="radio" name={props.name} value="200" style={{ display: 'none' }} checked={selectedValue === '200'} onChange={() => { }} />
                                                                    $200                                                </label>
                                                                <label style={radioStyle('300')} onClick={() => handleChange('300')}>
                                                                    <input type="radio" name={props.name} value="300" style={{ display: 'none' }} checked={selectedValue === '300'} onChange={() => { }} />
                                                                    $300
                                                                </label>
                                                                <label style={radioStyle('400')} onClick={() => handleChange('400')}>
                                                                    <input type="radio" name={props.name} value="400" style={{ display: 'none' }} checked={selectedValue === '400'} onChange={() => { }} />
                                                                    $400
                                                                </label>
                                                                <label style={radioStyle('500')} onClick={() => handleChange('500')}>
                                                                    <input type="radio" name={props.name} value="500" style={{ display: 'none' }} checked={selectedValue === '500'} onChange={() => { }} />
                                                                    $500
                                                                </label>
                                                            </EthBtn>
                                                            <Divider />
                                                            <br />
                                                            <Div>
                                                                <SectionSmallHeading>1 Pulse (PLS)</SectionSmallHeading>
                                                                <SectionSmallHeading>$0.009</SectionSmallHeading>
                                                            </Div>
                                                            <Div>
                                                                <SectionSmallHeading>You deposit</SectionSmallHeading>
                                                                <SectionSmallHeading>-----</SectionSmallHeading>
                                                            </Div>
                                                            <Div>
                                                                <SectionSmallHeading>You will recieve</SectionSmallHeading>
                                                                <SectionSmallHeading>-----</SectionSmallHeading>
                                                            </Div>
                                                            <ConnectButt disabled={!isButtonEnabled} m="20px 0" mw="100%" onClick={handleOpenModal}>Deposit</ConnectButt>
                                                        </div>
                                                    </DivWrap>
                                                </Grid>
                                            </Grid>
                                            {/* --------Modal --------*/}
                                            <Modals
                                                open={OpenModal}
                                                onClose={handleCloseModal}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <MainDiv>
                                                    <DivForWithDraw>
                                                        <img src={clock} />
                                                        <XButton onClick={() => handleCloseModal(false)}>X</XButton>
                                                        <SectionSmallHeading p="20px 0 0" align="center">You will receive your funds within the next 15 mins.</SectionSmallHeading>
                                                        <SectionSmallHeading p="20px 0" align="center">To check your Pulse tokens you will need to switch
                                                            over to the Pulse Network.</SectionSmallHeading>
                                                    </DivForWithDraw>
                                                </MainDiv>
                                            </Modals>
                                        </>
                            ) : (
                                <BuyNow onClick={() => window.ethereum.enable()}>Connect Wallet</BuyNow>
                            )}
                           
                        </Grid>
                    </GridWrapper>
                    <DashboardFooter />
                </Container>
            </SectionWrapper>
        </div>
    )
}

export default S1_Dashboard